import React from "react";
import "react-virtualized/styles.css";

export default function TableVirtualizedStyle() {

    return (
        <style type="text/css">{`
          .Table {
            width: 100%width: 100%;
            margin-top: 15px;
          }

          .headerRow,
          .evenRow,
          .oddRow {
            border-bottom: 1px solid #e0e0e0;
          }

          .oddRow {
            background-color: #fafafa;
          }

          .headerColumn {
            text-transform: none;
            /* background-color: red; */
          }

          .exampleColumn {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .ReactVirtualized__Table__rowColumn {
            margin: 0 !important;
            height: 100%;
//            border-bottom: 1px solid #e0e4e9;
            font-size: 13px;
          }

          .ReactVirtualized__Table__rowColumn div {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
          }

          .ReactVirtualized__Table__headerColumn {
            text-align: center;
            font-weight: 400;
            font-size: 12px;
            background-size: 14px;
          }

          .ReactVirtualized__Table__headerTruncatedText {
            z-index: 1000;
          }

          .ReactVirtualized__Table__sortableHeaderIcon {
            width: 2.1em;
            height: 2.1em;
            position: absolute;
            top: 2px;
          }

          .checkboxLabel {
            margin-left: .5rem;
          }

          .checkboxLabel:first-of-type {
            margin-left: 0;
          }

          .noRows {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1em;
            color: #bdbdbd;
          }

          .ReactVirtualized__Grid, .ReactVirtualized__List {
            direction: rtl !important;
          }

          .ltr {
            direction: ltr;
          }

          .rw-widget-picker {
            height: auto;
            top: 0px;
          }

          .rw-widget-input {
            box-shadow: none;
          }

          .round {
            border: 1px solid #ced4da;
            background-color: #fff;
            border-radius: 5px;
          }

          .bordered-round {
            height: 30px;
            background-color: #fff;
            border: 1px solid #ced4da;
            border-radius: 5px;
          }

          .filter-blur {
            filter: blur(8px);
            -webkit-filter: blur(8px);
          }

          .form-control:focus, .btn:focus {
            -webkit-box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.26);
            -moz-box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.26);
            box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.26);
            border-radius: 5px;
            border: 0
          }

          .ReactVirtualized__Table {
            position: absolute;
          }

          .ReactVirtualized__Table__headerRow {
            padding: 7px 0 0 0 !important;
            background-color: #F4F4F6;
          }

          .Table:focus {
            outline: 0;
          }

          .ReactVirtualized__Grid {
          }

          .ReactVirtualized__Table__row{
            height: 40px !important;
            box-shadow: 0 0 0 1px #ebedef !important;
            border-radius: 2px;
          }

        `}</style>
    );
}
